import React, { lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import SwiperWrapper from '@core/myta/components/DiscontinuedSwiperWrapper';
import { useDetectSwiperLoop } from '@core/myta/hooks/swiperLoop';

import Avatar from '@features/avatar/components/Avatar';
import LoadingProgress from '@components/LoadingProgress';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useEventAvatars } from '@features/avatar/hooks';
import { env } from 'env';
import ROUTES from '@constants/routes';
import {
  AVATAR_SKIN_BREAKPOINTS,
  AVATAR_SKIN_SLIDER_WIDTH_BREAKPOINTS,
} from '@core/myta/constants';

const Avaturn = lazy(() => import('@features/avaturn/components/Avaturn'));
const Totem = lazy(() => import('@features/readyPlayMe/components/Totem'));

const { REACT_APP_FEATURE_AVATURN, REACT_APP_FEATURE_READY_PLAY_ME } = env;

const isReadyPlayActive = REACT_APP_FEATURE_READY_PLAY_ME === 'true';
const isAvaturnActive = REACT_APP_FEATURE_AVATURN === 'true';

const READY_PLAYER_COUNT = isReadyPlayActive ? 1 : 0;
const AVATURN_COUNT = isAvaturnActive ? 1 : 0;

const ChooseAvatar = () => {
  const navigate = useNavigate();
  const { currentEventId } = useMytaverseEvent();

  const { eventAvatars, loadingAvatars, handleChoseAvatar } = useEventAvatars();

  const loop = useDetectSwiperLoop(
    eventAvatars.length + READY_PLAYER_COUNT + AVATURN_COUNT,
  );

  if (loadingAvatars || loop === null) {
    return <LoadingProgress fullHeight />;
  }

  return (
    <SwiperWrapper
      breakpoints={AVATAR_SKIN_BREAKPOINTS}
      loop={loop}
      sliderWidth={AVATAR_SKIN_SLIDER_WIDTH_BREAKPOINTS}
    >
      {eventAvatars.map((avatar) => (
        <SwiperSlide key={avatar.avatarId}>
          <Avatar avatar={avatar} onClick={() => handleChoseAvatar(avatar)} />
        </SwiperSlide>
      ))}

      {isReadyPlayActive && (
        <Suspense fallback={<LoadingProgress />}>
          <SwiperSlide>
            <Totem
              onClick={() => navigate(ROUTES.READY_PLAYER(currentEventId))}
            />
          </SwiperSlide>
        </Suspense>
      )}

      {isAvaturnActive && (
        <Suspense fallback={<LoadingProgress />}>
          <SwiperSlide>
            <Avaturn onClick={() => navigate(ROUTES.AVATURN(currentEventId))} />
          </SwiperSlide>
        </Suspense>
      )}
    </SwiperWrapper>
  );
};

export default ChooseAvatar;
